import Axios from "axios";

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { dateFormat } from "../../utils";
// import ReactLoading from "react-loading";
import "./styles.less";
const svgString = `<svg width="100%" height="30%"
 viewBox="0 0 150 150" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <style>
    #path-f {
      fill: none;
      stroke: #eaebee;
      stroke-width: 10;
      stroke-dasharray: 100 220;
      animation: dash 40s infinite linear forwards;
    }
    #path-b {
      fill: none;
      stroke: #0080ff;
      stroke-width: 8;
      stroke-linecap: round;
      stroke-linejoin: round;
    }
    @keyframes dash {
      to {
        stroke-dashoffset: 12000;
      }
    }
  </style>
  <title>Loading</title>
  <g id="单独" transform="translate(25.000000, 16.000000)" fill-rule="nonzero"  stroke-width="2" >
    <path d="M50,0 L0,30 C0,31 0,32 0,33 C0,69 20,100 50,116 C79,100 100,69 100,33 C100,32 99,31 99,30 L50,0 Z" id="path-b"/>
    <path d="M50,0 L0,30 C0,31 0,32 0,33 C0,69 20,100 50,116 C79,100 100,69 100,33 C100,32 99,31 99,30 L50,0 Z" id="path-f"/>
  </g>
</svg>`;
const LodingRender = () => {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
        alignContent: "center",
      }}
    >
      {/* <ReactLoading
        type="spinningBubbles"
        color="#215ae5"
        height={40}
        width={40}
      /> */}
      <div dangerouslySetInnerHTML={{ __html: svgString }} />
    </div>
  );
};
export const TimelineContent = () => {
  const [editionData, setEditionData] = useState([]);

  const { i18n, t } = useTranslation();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    Axios.get(`/api/changelogs?limit=100`).then((res) => {
      const result = res?.data.data;
      // if (result.code === 200) {
      setEditionData(result.list || []);
      setLoading(false);
      // } else {
      // }
    });
  }, []);
  return (
    <div className="timeline-content">
      {loading && LodingRender()}
      {!loading &&
        editionData.map((edition, index) => {
          return (
            <div className="timeline-edition-item">
              <div className="timeline-edition-title-box">
                <div className="edition-title">V{edition.version}</div>
                <div className="edition-date">
                  {dateFormat(edition.createdAt, "date")}
                </div>

                {index === 0 && (
                  <span className="edition-tag">
                    {t("common.timeline-publish")}
                  </span>
                )}
              </div>
              <div className="timeline-content-box">
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      i18n.language === "zh-CN"
                        ? edition.detailedChangeLog
                        : edition.detailedChangeLogEn,
                  }}
                ></div>
              </div>
            </div>
          );
        })}
    </div>
  );
};
